import React, {Component} from 'react';
import './App.css';
import DashboardPage from "./pages/DashboardPage";
import AppBar from '@material-ui/core/AppBar';
import Toolbar from "@material-ui/core/Toolbar/Toolbar";
import Typography from '@material-ui/core/Typography';
import CssBaseline from '@material-ui/core/CssBaseline';
import {withStyles} from '@material-ui/core/styles';
import 'typeface-roboto';
import {fetchJobs} from "./state/actions/jobs";
import {connect} from "react-redux";
import {Link, Route, Switch} from 'react-router-dom';
import {Helmet} from "react-helmet";
import {title} from './website-utils/meta';
import config from "./config";
import {fetchBusiness} from "./state/actions/business";
import {loginSuccess, logout} from "./state/actions/auth";
import {fetchUser} from "./state/actions/user";
import AnnouncementModal from './modals/AnnouncementModal';


const styles = (theme) => ({
  content: {
    flexGrow: '1',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-start',
    alignItems: 'stretch',
  },
  logOut: {
    flex: 1,
    textAlign: 'right',
    display: 'flex',
    justifyContent: 'flex-end',
    cursor: 'pointer',
  },
});

class App extends Component {
  componentDidMount() {
    this.props.fetchJobs();
    window.prerenderReady = false;
    // Check if user is logged in already
    const token = window.localStorage.getItem('authToken');
    if (token) {
      this.props.loginSuccess(token);
      // this.props.fetchBusiness();
    }
    this.props.fetchUser();
  }

  logOut = () => {
    localStorage.removeItem('businessId');
    this.props.logout();
    this.props.history.push(config.routes.business);
  };

  render() {
    const {classes} = this.props;

    return (
      <div className="App" style={{display: 'flex', flexDirection: 'column'}}>
        <CssBaseline/>
        <Helmet>
          {this.props.app && title('SingleShift - ' + this.props.app.title)}
        </Helmet>
        <AnnouncementModal/>
        <AppBar color={'secondary'}>
          <Toolbar>
            <Typography variant="title" color="inherit" align={'left'} style={{flex: 3, flexGrow: 1}}>
              {(this.props.app && this.props.app.title) ? this.props.app.title : 'SingleShift'}
            </Typography>
            <Typography variant="body2" style={{cursor: 'pointer', marginRight: '32px'}}>Support: +65 8753 8329</Typography>
            <Typography variant="body2" style={{cursor: 'pointer'}} onClick={this.logOut}>Log out</Typography>
          </Toolbar>
        </AppBar>
        <Toolbar/>
        <div className={classes.content}>
          <Switch>
            <Route path={'/:slug/shifts/:action(create)'} component={DashboardPage}/>
            <Route path={'/:slug/shifts/:shiftId'} component={DashboardPage}/>
            <Route path={'/:slug'} component={DashboardPage}/>
          </Switch>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  app: state.app,
});

const mapDispatchToProps = (dispatch) => ({
  fetchJobs: () => dispatch(fetchJobs()),
  loginSuccess: (token) => dispatch(loginSuccess(token)),
  fetchBusiness: () => dispatch(fetchBusiness()),
  logout: () => dispatch(logout()),
  fetchUser: () => dispatch(fetchUser()),
});

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(App));



// WEBPACK FOOTER //
// ./src/App.js